import { push } from 'react-router-redux';
import get from 'lodash/get';
import isUndefined from 'lodash/isUndefined';
import isEmpty from 'lodash/isEmpty';

import { joinPath } from '@eb/path-utils';

import {
    sendSoftAccountActivationEmail as sendSoftAccountActivationEmailApi,
    sendResetPasswordEmail as sendResetPasswordEmailApi,
    sendEmailLinkAccount as sendEmailLinkAccountApi,
} from '../api/emails';

import {
    trackPasswordForgotten,
    trackPasswordForgottenMailFailed,
    trackPasswordForgottenMailSent,
    trackMagicLinkSent,
    trackMagicLinkClicked,
    trackMagicLinkFailed,
    trackCheckEmailPrompt,
} from './gaTracking';
import { getEmailFromState, setShowModal, setIsLoading } from './auth';
import { onSkipEmailDelivery } from './mocks';

import {
    RESET_PASSWORD_STATUS_PATH,
    SOFT_ACCOUNT_STATUS_PATH,
    BASE_URL,
    LINK_SOCIAL_ACCOUNT_PATH,
} from '../constants';
import { GA_EVENTBRITE, GA_FACEBOOK, GA_APPLE } from '../constants/analytics';

export const SET_SEND_EMAIL_LINK_ACCOUNT = 'SET_SEND_EMAIL_LINK_ACCOUNT';
export const setSendEmailLinkAccount = (sent) => ({
    type: SET_SEND_EMAIL_LINK_ACCOUNT,
    payload: sent,
});

export const sendSoftAccountActivationEmail = () => (dispatch, getState) => {
    const state = getState();
    const {
        authentication: { email, referrer },
    } = state;

    return (
        sendSoftAccountActivationEmailApi(email, referrer)
            .then(() =>
                dispatch(
                    push(
                        joinPath(BASE_URL, 'status', SOFT_ACCOUNT_STATUS_PATH),
                    ),
                ),
            )
            .then(() => trackCheckEmailPrompt({ state }))
            //There was no existent catch for this action, any error would go up without control
            .catch(() => Promise.resolve())
    );
};

/**
 * Old method but used
 * @deprecated
 * TODO: There is a new implementation under ./forgotPassword
 *
 */
export const sendResetPasswordEmail = ({
    sourceProvider = GA_EVENTBRITE,
    mustLinkAccount = false,
}) => (dispatch, getState) => {
    const state = getState();

    if (!isUndefined(state.authentication.socialData.sourceProvider)) {
        sourceProvider = GA_FACEBOOK;
        mustLinkAccount = true;
    }
    if (!isEmpty(state.authentication.socialAuthenticationData.apple)) {
        sourceProvider = GA_APPLE;
        mustLinkAccount = true;
    }

    trackPasswordForgotten({
        sourceProvider,
        state,
    });

    return sendResetPasswordEmailApi(
        getEmailFromState(getState),
        mustLinkAccount,
        sourceProvider,
    )
        .then(() =>
            dispatch(
                push(joinPath(BASE_URL, 'status', RESET_PASSWORD_STATUS_PATH)),
            ),
        )
        .then(() =>
            trackPasswordForgottenMailSent({
                sourceProvider,
                state,
            }),
        )
        .catch((error) => {
            trackPasswordForgottenMailFailed({
                errorMessage: get(
                    error,
                    'parsedError.error',
                    get(error, 'response.statusText', 'Error not defined'),
                ),
                state,
            });
        });
};

/* Function to send email to link account */
export const sendEmailLinkAccount = () => (dispatch, getState) => {
    const state = getState();
    const {
        authentication: {
            socialData: { sourceProvider },
            skipSocialCalls,
        },
    } = state;

    dispatch(setShowModal(true));
    dispatch(setIsLoading(true));

    trackMagicLinkClicked({ sourceProvider, state });

    return sendEmailLinkAccountApi(getEmailFromState(getState), sourceProvider)
        .then((response) => {
            trackMagicLinkSent({
                sourceProvider: sourceProvider,
                state,
            });
            dispatch(setSendEmailLinkAccount(true));
            dispatch(setIsLoading(false));

            /**
             * In dev we benefit from having this mocked as it allow us to test the flow
             * without needing an email service.
             * Enables local testing and cypress testing.
             */
            if (skipSocialCalls && response && response.skipEmailDelivery) {
                onSkipEmailDelivery({
                    callback: () => {
                        dispatch(
                            push(
                                joinPath(
                                    BASE_URL,
                                    `${LINK_SOCIAL_ACCOUNT_PATH}/?h=123456ABCDEF&external_provider=facebook`,
                                ),
                            ),
                        );
                    },
                });
            }
        })
        .catch((error) => {
            trackMagicLinkFailed({
                errorMessage: get(
                    error,
                    'response.parsedError.error',
                    get(error, 'response.statusText', 'Error not defined'),
                ),
                state,
            });
            dispatch(setSendEmailLinkAccount(false));
            dispatch(setIsLoading(false));
        });
};
